/*
 * @Author: 张帮辉
 * @LastEditors: 张帮辉
 * @Date: 2022-03-07 17:33:14
 * @LastEditTime: 2022-03-07 17:34:52
 * @Description: file content
 */

import type {
  IShipNetModel,
  IShipNetStore,
} from '@monorepo/types/appSettings/shipNet/shipNet.types';

const initState: IShipNetStore = {
  isInit: true,
  tableList: [],
  total: 0,
  query: {
    pageSize: 50,
    page: 1,
    query_name: '',
  },
};

const shipNetStore: IShipNetModel = {
  namespace: 'shipNetStore',
  state: initState,
  reducers: {
    save(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
    resetInit() {
      return { ...initState };
    },
  },
};

export default shipNetStore;
